'use strict';

import detectIE from './utils/detectIE';

import './liferay-custom';

import { AppContext } from './app-context';
import './utils/DataEventSocketSupport';
import * as UidUtil from './utils/uid-util.js';
import * as BoolUtil from './utils/bool-util';
import * as DataUtil from './utils/data-util.js';
import * as ApiUtil from './utils/api-util.js';
import * as RoleUtil from './utils/role-util.js';
import * as FormDataUtil from './utils/form-data-util.js';
import shallowEqual, { equalArray } from './utils/shallowEqual';
import deepEqual from './utils/deepEqual';
import deepMerge from './utils/deepMerge';
import { amdDefine, amdRequire, loadModuleByClassName } from './utils/amd-utils';
import debounce from './utils/debounce';
import warning from './utils/warning.js';
import FluxReduceStore from 'flux/lib/FluxReduceStore';
import FluxContainer from 'flux/lib/FluxContainer';
import { default as rb, utils } from 'external/react-bootstrap';

if (__DEV__) {
    console.warn('############ ***************** ####################');
    console.warn('############ ***************** ####################');
    console.warn('############ DEVELOPMENT BUILD ####################');
    console.warn('############ ***************** ####################');
    console.warn('############ ***************** ####################');
}
window.__DEBUG__ = localStorage.REACT_WEB_DEBUG;
window.LOGS = {
    DISPATCHER: false,
    ...localStorage.LOGS
};

if (__DEBUG__) {
    console.warn('############  __DEBUG__ MODE   ####################');
}

//Utils
export { default as FormValidationUtil } from './utils/form-validation-util';
export { imageAvailable } from './utils/imageAvailable';

export { AppContext };

// Actions
export { default as FormActions } from './actions/FormActions';
export { default as ConfigActions } from './actions/ConfigActions';
export { default as RemoteDataActions } from './actions/RemoteDataActions';

// Stores
export { default as ConfigStore } from './stores/ConfigStore';
export { default as ComputedQueryParamsDataStore } from './stores/ComputedQueryParamsDataStore';
export { default as ClassRemoteDataStore } from './stores/ClassRemoteDataStore';
export {
    default as RemoteDataStore, isList, isAttachedList, DEFAULT_DATA_ITEM, DEFAULT_DATA_LIST
} from './stores/RemoteDataStore';
export { default as TimeSeriesRemoteDataStore } from './stores/TimeSeriesRemoteDataStore';

export * from './stores/StoreFactory';

if (__DEBUG__) {
    // if (!(detectIE() <= 11)) AsyncListComponent();
}

AppContext.registerBundle({
    webApis: {},
    contextElements: {}
});

// Components
export { default as ValidationMessage } from './components/ValidationMessage';
export { default as PortletComponent } from './components/PortletComponent';
export { default as PluginComponent } from './components/PluginComponent';
export { default as wrapWithFormContainer } from './components/FormContainer';
export { default as wrapWithCommonFormContainer } from './components/CommonFormContainer';
export { default as ConfirmFormContainer } from './components/ConfirmFormContainer';
export { default as ScrollableDataList } from './components/ScrollableDataList';
export { default as ScrollableDataListRV } from './components/ScrollableDataListRV';
export { default as DraggableList } from './components/DraggableList';
export { default as flagHOC, FlagComponent } from './components/FlagHOC';
export { default as LiferayFormComponent } from './components/LiferayFormComponent';
export * from './components/CustomModalComponents';
export { default as Title } from './components/Title';
export { default as FaIcon } from './components/FaIcon';
export { WYSIWYGEditor } from './components/WYSIWYGEditor';
export { Header } from './components/Header';
export { PdfViewer } from './components/PdfViewer';

export { default as ContextContainer } from './utils/ContextContainer';
export { default as DataLinkContainer } from './utils/DataLinkContainer';
export { default as AmdRequireComponent } from './utils/amd-utils';

export {
    UidUtil,
    BoolUtil,
    DataUtil,
    RoleUtil,
    ApiUtil,
    FormDataUtil,
    shallowEqual,
    equalArray,
    deepEqual,
    deepMerge,
    amdRequire,
    amdDefine,
    loadModuleByClassName,
    debounce,
    warning,
    detectIE
};

export { default as translation } from './utils/translation';

// Constants
export { default as ActionTypesCommon } from './constants/ActionTypesCommon';
export { default as DataNames } from './constants/DataNames';
export { default as AsyncState } from './constants/AsyncState';

export { FluxReduceStore as ReduceStore };
export { FluxContainer };

/*
For JournalListWidget special style 'selection-on' : 'selection-off' -> better use react-bootstrap ToogleButton*/

console.info('UTILS', utils, rb);



// WEBPACK FOOTER //
// ./js/liferay-widgets-react-web.js